export const PROJECT_STATUS = {
	ARCHIVED: "ARCHIVED",
	ACTIVE: "ACTIVE",
};
